import React from 'react';
import PageTransition from 'gatsby-plugin-page-transitions';

import Header from './header';
import 'css-reset-and-normalize';

import './global.css';

type Props = {
  children: React.ReactNode;
};

const Layout = ({ children }: Props) => {
  return (
    <div className="wrapper">
      <Header />
      <main>
        <PageTransition>{children}</PageTransition>
      </main>
    </div>
  );
};

export default Layout;
